import api from '@/shared/api/client'
import type {
  AnnouncementListItem,
  AnnouncementDetail,
  AnnouncementListFilters,
  AnnouncementDeliveryPrefs,
  Paginated,
} from '../types'

/**
 * Updates & Announcements reader API. Base URL is /api/v1/app (axios client),
 * so paths are relative to that. The whole module 404s server-side when the
 * UPDATES_MODULE_ENABLED flag is off — callers should gate on canViewAnnouncements.
 */
export const announcementsApi = {
  list: (filters: AnnouncementListFilters = {}) =>
    api.get<Paginated<AnnouncementListItem>>('/announcements', { params: filters }).then((r) => r.data),

  unreadCount: () =>
    api.get<{ data: { total: number } }>('/announcements/unread-count').then((r) => r.data.data),

  detail: (id: string) =>
    api.get<{ data: AnnouncementDetail }>(`/announcements/${id}`).then((r) => r.data.data),

  markRead: (id: string) =>
    api.post(`/announcements/${id}/read`).then((r) => r.data),

  dismiss: (id: string) =>
    api.post(`/announcements/${id}/dismiss`).then((r) => r.data),

  acknowledge: (id: string) =>
    api.post(`/announcements/${id}/acknowledge`).then((r) => r.data),

  getPreferences: () =>
    api.get<{ data: AnnouncementDeliveryPrefs }>('/announcements/preferences').then((r) => r.data.data),

  updatePreferences: (patch: Partial<AnnouncementDeliveryPrefs>) =>
    api.patch<{ data: AnnouncementDeliveryPrefs }>('/announcements/preferences', patch).then((r) => r.data.data),
}
